var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('sr-not-found',{attrs:{"thing":"timeline"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Timeline")]},proxy:true},{key:"content",fn:function(){return [_vm._v("Coming Soon")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }